var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col",attrs:{"id":"app"}},[_c('NavBar',{attrs:{"id":"navbar"}}),(_vm.$route.matched.length)?[_c('router-view',{staticClass:"flex-1"})]:_vm._e(),_c('PlayerElement',{attrs:{"id":"player"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }